import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import createHistory  from 'history/createBrowserHistory';
import { routerMiddleware } from 'react-router-redux';

import rootReducer from './reducers';

export const history = createHistory();

const initialState = {};
/*const enhancers = [];*/
const middleware = [
    thunk,
    routerMiddleware(history)
];

const composeEnhancers = compose(
    applyMiddleware(...middleware),
    /* 下面一行不注释掉，手机端浏览器打开为空白页 */
    /*window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()  debug */
)

const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers
)

export default store;


// WEBPACK FOOTER //
// ./src/store.js